/**
 * Централизованный список всех GLTF моделей в проекте
 * Используется для предзагрузки и в компонентах
 */

export const MODELS = {
  // Машина
  CAR: "/car/car.glb",

  // Деревья
  TREE: "/car/tree.glb",
  TREE_ALL_COLOR: "/tree/treeAllColor.glb",
  TREE_RED: "/tree/treeRed.glb",
  TREE_YELLOW: "/tree/treeYellow.glb",
  TREE_ORANGE: "/tree/treeOrange.glb",
  MINI_TREE_GREEN: "/tree/miniTreeGreen.glb",
  MINI_TREE_RED: "/tree/miniTreeRed.glb",
  MINI_TREE_YELLOW: "/tree/miniTreeYellow.glb",
  MINI_TREE_ORANGE: "/tree/miniTreeOrange.glb",

  // Указатели зон
  POINTER_GAME_ZONE: "/pointers/gamezone.glb",
  POINTER_WORK_ZONE: "/pointers/workzone.glb",
  POINTER_HOBBY_ZONE: "/pointers/hobbyzone.glb",

  // Объекты жизни
  PLANT: "/plant/Plant.glb",
  DUMBBELL: "/dumbbell/Dumbbell.glb",
  TELEGRAM: "/telegram/telegram.glb",
  PIZZA_FINISH: "/pizza/pizzaFinish.glb",
  SNOWBOARD: "/car/snowboardColored.glb",
};
